/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  MarkerF,
  useLoadScript,
} from "@react-google-maps/api";
import SearchLocation from "../search/SearchLocation";
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper components
import "swiper/css"; // Import Swiper core CSS
import "swiper/css/navigation"; // Import Swiper navigation styles
import "swiper/css/pagination"; // Import Swiper pagination styles
import { Navigation } from "swiper/modules";
import "./custom-tooltip.css";
import { useFormContext, useListing } from "@/providers";
import { Link } from "react-router-dom";
import {
  DEFAULT_TYPE_ICONS,
  SNAZZY_MAP_STYLES,
  renderImage,
} from "@/constants";
import { getBusinesss } from "@/utils";
import { BusinessTypeSlider } from "../AllBusinesses";

const libraries = ["places"]; // Add more libraries if needed, e.g., 'geometry', 'drawing'

const LocationMap = () => {
  // const [filterItem, setFilterItem] = useState("");
  const [selectedMarker, setSelectedMarker] = useState(null);
  const { setValue, watch } = useFormContext();
  // let { data } = useContext(ThemeContext);
  const { filteredListings } = useListing();
  const [type, setType] = useState("stays");
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(false); // Add loading state

  const [showFilters, setShowFilters] = useState(true); // State to manage filter visibility

  const [center, setCenter] = useState({
    lat: 39.5,
    lng: -100.0,
  });

  const distance_from_runway = watch("closest_runway");
  // Fetch restaurants with the search query
  const fetchBusinesses = useCallback(async () => {
    try {
      setLoading(true); // Set loading to true when fetching data
      const { data } = await getBusinesss({
        type,
        // distance_from_runway: watch("closest_runway"),
      });
      setBusinesses(data);
    } catch (error) {
      console.error("Error fetching businesses:", error);
    } finally {
      setLoading(false); // Set loading to false when the fetch is done
    }
  }, [type]);

  // Trigger fetch on page load
  useEffect(() => {
    type !== "stays" && fetchBusinesses();
  }, [fetchBusinesses, distance_from_runway]); // This will run only once when the component is mounted

  const [zoom, setZoom] = useState(3.6);

  const getLabelColor = (distance) => {
    const location = parseInt(distance);
    if (location === 0) {
      return "8ec639";
    } else if (location > 0 && location <= 1) {
      return "ffff00";
    } else if (location > 1 && location <= 3) {
      return "f17489";
    } else if (location > 3 && location <= 7) {
      return "ff9900";
    } else {
      return "52c4d7";
    }
  };

  const createSVGIcon = (color, price, type) => {
    const svgTemplate = `<svg xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="2" width="50" height="20" rx="10" ry="10" fill="${color}"/>
      <text x="40%" y="15" text-anchor="middle" font-size="10" font-weight="bold" fill="black" font-family="Arial, sans-serif">
        $${type === "stays" ? Math.ceil(price) : price}
      </text>
    </svg>`;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
      svgTemplate
    )}`;
  };

  // Enhanced marker design function
  const createBusinessMarker = (color) => {
    const svgTemplate = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="2" width="20" height="20" rx="10" fill="${color}" stroke="white" stroke-width="4"/>
        </svg>
      `;

    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
      svgTemplate
    )}`;
  };
  console.log("businesses", businesses);

  const mapRef = useRef(null);
  const onLoad = useCallback((map) => {
    mapRef.current = map;

    const mapTypeControl = mapRef.current
      .getDiv()
      .querySelector(".gm-style-mtc");
    if (mapTypeControl) {
      mapTypeControl.style.maxWidth = "100px"; // Adjust this value as needed
    }
    // Create custom zoom controls
    const zoomControlDiv = document.createElement("div");
    zoomControlDiv.style.display = "flex";
    zoomControlDiv.style.marginTop = "70px";
    zoomControlDiv.style.marginLeft = "-179px";

    const buttonStyle = {
      fontSize: "18px",
      width: "40px",
      height: "40px",
      display: "flex",
      borderRadius: "4px 4px 4px 4px",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#24393b",
      color: "white",
      border: "none",
      marginRight: "5px",
      cursor: "pointer",
    };

    const zoomInButton = document.createElement("button");
    zoomInButton.textContent = "+";

    Object.assign(zoomInButton.style, buttonStyle);

    const zoomOutButton = document.createElement("button");
    zoomOutButton.textContent = "-";
    Object.assign(zoomOutButton.style, buttonStyle);

    zoomControlDiv.appendChild(zoomInButton);
    zoomControlDiv.appendChild(zoomOutButton);

    // Append custom controls to the map
    map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(
      zoomControlDiv
    );

    // Add event listeners for zooming
    zoomInButton.addEventListener("click", () => {
      map.setZoom(map.getZoom() + 1);
    });

    zoomOutButton.addEventListener("click", () => {
      map.setZoom(map.getZoom() - 1);
    });
  }, []);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyDXJS_VZMhnp0szh92aZGg8RHszz6RMQN8",
    libraries, // Include libraries here
  });

  const selectedImage = selectedMarker?.images?.filter(
    (item) => item?.type === "photo"
  )?.[0]?.image;

  const iconClass = DEFAULT_TYPE_ICONS[type] || DEFAULT_TYPE_ICONS.default;

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div className="h=[93vh] relative w-full bg-none">
      <GoogleMap
        mapContainerStyle={{ height: "80vh", width: "100%" }}
        center={center}
        zoom={zoom}
        onLoad={onLoad}
        apiKey="AIzaSyDXJS_VZMhnp0szh92aZGg8RHszz6RMQN8"
        options={{
          zoomControl: false,
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: window.google.maps.ControlPosition.TOP_LEFT,
          },
          styles: SNAZZY_MAP_STYLES,
        }}
        ref={mapRef}
        className="custom-map-type-control"
      >
        {loading && (
          <div className="relative z-50 flex flex-col items-center justify-center h-screen gap-5 bg-white opacity-60">
            <img
              className="h-auto w-36 md:w-44" // Responsive sizes
              src="/image/fly-inn-logo.svg"
              alt="Fly Inn Logo"
            />
            <div className="text-2xl text-bold">
              {" "}
              Please Wait while we load your data!
            </div>
          </div>
        )}

        {type === "stays" &&
          filteredListings?.map((marker, index) => (
            <MarkerF
              key={index}
              position={{
                lat: parseFloat(marker.fake_latitude || marker.latitude),
                lng: parseFloat(marker.fake_longitude || marker.longitude),
              }}
              onClick={() => setSelectedMarker(marker)}
              icon={{
                url: createSVGIcon(
                  `#${getLabelColor(
                    marker.closest_runway_distance === ""
                      ? 0
                      : marker.closest_runway_distance
                  )}`,
                  marker.nightly_price
                ),
                scaledSize: new window.google.maps.Size(80, 50),
              }}
            />
          ))}

        {type !== "stays" &&
          businesses?.map((marker, index) => {
            const distance =
              marker.distance_from_runway === ""
                ? 0
                : marker.distance_from_runway;
            const color = `#${getLabelColor(distance)}`;

            return (
              <MarkerF
                key={index}
                position={{
                  lat: parseFloat(marker?.latitude),
                  lng: parseFloat(marker?.longitude),
                }}
                onClick={() => {
                  setSelectedMarker(marker);
                }}
                icon={{
                  url: createBusinessMarker(color, marker.type, distance),
                  scaledSize: new window.google.maps.Size(25, 25),
                  anchor: new window.google.maps.Point(25, 50),
                }}
              />
            );
          })}

        {type === "stays" && selectedMarker && (
          <InfoWindow
            position={{
              lat: parseFloat(
                selectedMarker.fake_latitude || selectedMarker.latitude
              ),
              lng: parseFloat(
                selectedMarker.fake_longitude || selectedMarker.longitude
              ),
            }}
            options={{
              pixelOffset: new window.google.maps.Size(0, -30), // Adjust position relative to marker
            }}
            onCloseClick={() => setSelectedMarker(null)} // If you still want the default close behavior
          >
            <div className="overflow-hidden bg-white shadow-lg w-72 rounded-xl">
              <Link to={`/listing/${selectedMarker?.id}`}>
                {/* Image Section */}
                <div className="w-full h-32">
                  {/* Swiper Slider */}
                  <Swiper
                    modules={[Navigation]}
                    navigation
                    pagination={{ clickable: true }}
                    className="w-full h-44 map-card-image hide-navigation" // Add custom class
                  >
                    {selectedMarker.images?.map((image, index) => (
                      <SwiperSlide key={index}>
                        <img
                          // src={image.url}
                          src={`${
                            renderImage(image.image) || "/image/inovate6.jpg"
                          }`}
                          alt={`Image ${index + 1}`}
                          className="object-cover w-full h-full"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                {/* Info Section */}
                <div className="px-4 py-2">
                  <h4 className="text-sm font-semibold text-gray-800 !m-0">
                    {selectedMarker?.city}, {selectedMarker?.country}
                  </h4>
                  <p className="text-xs text-gray-500 mt-1 truncate !p-0 !m-0">
                    Stay at {selectedMarker?.title}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="font-bold text-gray-800 text-md">
                      ${selectedMarker.nightly_price}
                      <span className="text-xs font-medium text-gray-500">
                        {" "}
                        / night
                      </span>
                    </div>
                    {/* <div className="text-sm text-gray-500">Jan 2 – 7</div> */}
                  </div>
                </div>
              </Link>
              {/* Bottom Close Button */}
              <button
                className="z-[50] w-6 h-6 group hover:text-gray-500 rounded-full shadow-md hover:bg-gray-100 bg-gray-300 flex items-center justify-center absolute right-3 top-3"
                onClick={() => setSelectedMarker(null)}
              >
                <i className="text-white fas fa-times group-hover:text-gray-500"></i>
              </button>
            </div>
          </InfoWindow>
        )}

        {type !== "stays" && selectedMarker && (
          <InfoWindow
            position={{
              lat: parseFloat(selectedMarker?.latitude),
              lng: parseFloat(selectedMarker?.longitude),
            }}
            options={{
              pixelOffset: new window.google.maps.Size(0, -30),
            }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div className="relative w-80 overflow-hidden bg-white rounded-xl shadow-xl border border-gray-100">
              {/* Header with gradient background, business image, and logo */}
              <div className="relative w-full h-40 overflow-hidden">
                {/* Business Image */}
                <img
                  src={
                    `https://s3.amazonaws.com/flyinn-app-bucket/${selectedImage}` ||
                    "https://s3.amazonaws.com/flyinn-app-bucket/business_images/1751304310_ivan-stern-LOLSb7m6XkU-unsplash.jpg"
                  }
                  alt={selectedMarker?.name || "Business Image"}
                  className="w-full h-full object-cover"
                />
                {/* Gradient Overlay for Text Readability */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80"></div>

                {/* Logo and Text Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end">
                  {/* Logo (conditionally rendered) */}

                  {/* Text Content */}
                  <div>
                    <h3 className="text-xl font-bold text-white flex items-center mb-0 leading-tight">
                      {/* <i
                        className={`fas fa-${
                          selectedMarker.type === "restaurants"
                            ? "utensils"
                            : selectedMarker.type === "fuel"
                            ? "gas-pump"
                            : selectedMarker.type === "maintenance"
                            ? "tools"
                            : selectedMarker.type === "parking"
                            ? "parking"
                            : selectedMarker.type === "hotels"
                            ? "hotel"
                            : selectedMarker.type === "shopping"
                            ? "shopping-bag"
                            : "store"
                        } mr-2 text-white`}
                      ></i> */}
                      {selectedMarker?.business_logo ? (
                        <div className="flex-shrink-0 mr-1">
                          <img
                            src={`https://s3.amazonaws.com/flyinn-app-bucket/${selectedMarker.business_logo}`}
                            alt={`Logo`}
                            className="w-12 h-12 rounded-full border-2 border-white shadow-lg object-cover"
                          />
                        </div>
                      ) : (
                        <div className="w-28 h-28 flex items-center justify-center rounded-xl bg-gray-100 text-gray-400 border-2 border-dashed border-gray-300 shadow-inner">
                          {/* Display the FontAwesome icon dynamically */}
                          <i className={`fa ${iconClass} text-5xl`}></i>
                          {/* Or if you prefer emojis, map emojis based on type too */}
                          {/* <span className="text-5xl">{getTypeEmoji(business.type)}</span> */}
                        </div>
                      )}
                      {selectedMarker?.name}
                    </h3>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-2">
                {/* Location Info */}
                <div className="mb-3">
                  <div className="flex items-start mb-2">
                    <i className="fas fa-map-marker-alt text-blue-500 mt-1 mr-2"></i>
                    <div>
                      <p className="text-gray-700 font-medium text-sm !mb-0 !p-0">
                        {selectedMarker?.address}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Additional Details */}
                <div className="grid grid-cols-2 gap-2 !mb-1">
                  <div className="flex items-center bg-gray-50 p-2 rounded">
                    <div>
                      <p className="!text-[11px] !m-0 !p-0 text-gray-500">
                        Distance to Runway
                      </p>
                      <p className="text-sm font-medium  !m-0 !p-0">
                        {selectedMarker?.distance_from_runway || 0} miles
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center bg-gray-50 p-2 rounded">
                    <div>
                      <p className="!text-[11px] !m-0 !p-0 text-gray-500">
                        Airport
                      </p>
                      <p className="text-sm font-medium  !m-0 !p-0">
                        {selectedMarker?.airport || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Action Button */}
                <Link
                  to={`business/${selectedMarker?.type}/${selectedMarker?.business_id}`}
                  className="block w-full bg-gradient-to-r from-red-600 to-red-700 hover:!from-red-700 hover:!to-red-800 !text-white text-center py-2 px-4 rounded-lg font-medium transition-all duration-300 shadow-md"
                  target="_blank" // This opens the link in a new tab/window
                  rel="noopener noreferrer" // Recommended for security when using target="_blank"
                >
                  <i className="fas fa-external-link-alt !text-white mr-2"></i>
                  View Business Details
                </Link>
              </div>

              {/* Close Button */}
              <button
                className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white flex items-center justify-center shadow-lg hover:bg-gray-100 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMarker(null);
                }}
              >
                <i className="fas fa-times text-gray-600"></i>
              </button>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
      {showFilters && <BusinessTypeSlider type={type} setType={setType} />}
      <SearchLocation
        type={type}
        showFilters={showFilters}
        setShowFilters={setShowFilters}
      />
    </div>
  );
};

export default LocationMap;
